import { graphql } from "@/gql";

export const createSupplierAdminContactMutation = graphql(`
  mutation createSupplierAdminContact(
    $input: CreateSupplierAdminContactInput!
  ) {
    createSupplierAdminContact(input: $input) {
      id
    }
  }
`);

export const updateSupplierAdminContactMutation = graphql(`
  mutation updateSupplierAdminContact(
    $id: ID!
    $input: UpdateSupplierAdminContactInput!
  ) {
    updateSupplierAdminContact(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteSupplierAdminContactMutation = graphql(`
  mutation deleteSupplierAdminContact($id: ID!) {
    deleteSupplierAdminContact(id: $id) {
      id
    }
  }
`);
